import clsx from 'clsx';

import { Button } from '@components';
import { useAppContext } from '@molecules';

type LayoutProps = {
  user: React.ReactNode;
  menu: React.ReactNode;
  title: React.ReactNode;
  children: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ menu, title, user, children }) => {
  const { sidebarCollapsed, toggleSidebarCollapsed } = useAppContext();

  return (
    <div className="relative flex flex-row justify-between grow h-full overflow-hidden bg-bg">
      <div
        className={`shrink-0 grow-0 overflow-hidden w-[32rem] transition-[margin,opacity] duration-300 ease-in-out ${
          sidebarCollapsed ? 'opacity-0 -ml-[32rem]' : 'ml-0 opacity-100'
        }`}
      >
        <div className="h-full overflow-y-auto overflow-x-hidden">{menu}</div>
      </div>

      <Button
        round
        size="lg"
        type="empty"
        variant="icon"
        onClick={toggleSidebarCollapsed}
        icon={sidebarCollapsed ? 'bars' : 'columns'}
        className={clsx(
          'absolute z-20 transition-all shadow-md',
          !sidebarCollapsed
            ? 'left-[27.5rem] top-[2.1rem]'
            : 'left-[0.5rem] top-[1.2rem] opacity-30 hover:opacity-100'
        )}
      />

      <section className="flex flex-col flex-1 m-sm ml-0 bg-content p-lg pl-4xl rounded-md text-small overflow-hidden">
        <div className="h-[4rem] flex flex-row justify-between grow-0 gap-xl">
          {title}
          {user}
        </div>
        <div className="flex-1 overflow-y-auto overflow-x-auto flex mt-sm pt-sm px-sm -mx-sm">
          {children}
        </div>
      </section>
    </div>
  );
};

export default Layout;
export { Menu } from './Menu';
export { default as UserBar } from './UserBar';
